export default {
  open: 'ndvi - open',
  changePeriod: 'ndvi - change period',
  chooseDate: 'ndvi - choose date',
  changeLayer: 'ndvi - change layer',
}
